import { Injector } from "@angular/core";
import { EntityEnum } from "../../EntityEnum";
import { AuthorisedProductEntityListView } from "../../../Data/MedicinalProductData/AuthorisedProductEntityListView";
import { AuthorisedProductAutoUploadEntity } from "../Entity/AuthorisedProductAutoUploadEntity";
import { BaseNode } from "../../BaseNode";
import { OnDemandSimpleSearchListNode } from "../../OnDemandSimpleSearchListNode";


export class TreeNodeMedicinalProductsAuthorisedProduct extends OnDemandSimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new AuthorisedProductEntityListView(items), "Authorised Medicinal Products", useHist ? EntityEnum.authorisedProductHist : EntityEnum.authorisedProduct);
        this.useHist = useHist;
    }


    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `Authorised - ${model.ev_Code} - ${model.version} - ${model.productname}`;
        return this.addChildNode(AuthorisedProductAutoUploadEntity,labelTemplate, this,model, this.useHist, false, false);
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code','productname','productshortname','productgenericname','productcompanyname','productnamevariation'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for product records owned in the XEVMPD by your HQ";
    }
    
}